export class MissedTranslateParamsException extends Error {
    public name: string;

    constructor(targetString: string) {
        super(`Missed params object for translation string with variables. String: "${targetString}"`);
        this.name = 'MissedTranslateParamsException';
    }
}
